// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
// Components
import Grid from 'src/components/HTKit/Grid/Grid';
import ProductCardItem from 'src/components/Elements/ProductCard';
// Utils
import priceFormatter from 'src/containers/SimpliSafeLandingPage/helpers';
import { push, skuPath } from 'src/utils/paths';

const ProductCards = (props) => {
  const { skus } = props;
  const dispatch = useDispatch();
  if (skus.length === 0) return null;
  const handleClick = (seoName) => dispatch(push(skuPath(seoName)));
  return (
    <div className="paddingTop-medium1">
      <h4 className="n700 text-align-center marginBottom-medium1">
        Not getting the speed you need? We can help!
      </h4>
      <Grid.Fluid>
        <Grid.Row>
          {skus.map((sku, index) => {
            return (
              <Grid.Column sm={4} md={4} lg={3} key={index}>
                <ProductCardItem
                  shouldShowImage
                  cheapestPrice={priceFormatter(sku)}
                  image={sku.heroMobileImageUrl}
                  name={sku.name}
                  ratingAttributes={sku.ratingAttributes}
                  rating={sku.ratingAttributes.rating}
                  ratingCount={sku.ratingAttributes.ratingCount}
                  key={index}
                  onClick={() => handleClick(sku.seoName)}
                  showCta={false}
                  {...props}
                />
              </Grid.Column>
            );
          })}
        </Grid.Row>
      </Grid.Fluid>
    </div>
  );
};

ProductCards.propTypes = {
  skus: PropTypes.array.isRequired,
};

ProductCards.defaultProps = {
  skus: [],
};

export default ProductCards;
